import { useState } from 'react'
import { BookmarkPlus, Check } from 'lucide-react'
import { saveChart, saveResult, saveSpreadsheet } from '../../lib/chatApi'
import { useActiveWorkspace } from '../../lib/workspace'

type ArtifactKind = 'chart' | 'result' | 'spreadsheet'

// Ported from OLD: one-way pin into the gallery's saved set.
export function SaveArtifactButton({
  kind, id, saved, onSaved, className,
}: {
  kind: ArtifactKind
  id: string
  saved: boolean
  onSaved?: () => void
  className?: string
}) {
  const [saving, setSaving] = useState(false)
  const { activeWorkspaceKey } = useActiveWorkspace()

  const handleClick = async () => {
    if (saved || saving || !activeWorkspaceKey) return
    setSaving(true)
    try {
      if (kind === 'chart') await saveChart(activeWorkspaceKey, id)
      else if (kind === 'result') await saveResult(activeWorkspaceKey, id)
      else await saveSpreadsheet(activeWorkspaceKey, id)
      onSaved?.()
    } finally {
      setSaving(false)
    }
  }

  return (
    <button
      type="button"
      disabled={saved || saving || !activeWorkspaceKey}
      onClick={handleClick}
      className={
        className
        ?? [
          'inline-flex min-w-[88px] items-center justify-center gap-1.5 rounded-lg border px-3 py-1.5 text-xs font-semibold transition-colors',
          saved
            ? 'border-emerald-300 bg-emerald-100 text-emerald-800 cursor-default'
            : saving
              ? 'border-emerald-200 bg-emerald-50 text-emerald-700 cursor-wait'
              : 'border-emerald-200 bg-emerald-50 text-emerald-700 hover:bg-emerald-100',
        ].join(' ')
      }
    >
      {saved ? <Check size={13} /> : <BookmarkPlus size={13} />}
      {saved ? 'Saved' : saving ? 'Saving...' : 'Save'}
    </button>
  )
}
